export default __webpack_public_path__ + "static/media/ic-approve.dcb2ecd2.svg";